export function isRetryableOutage(error) {
    const text = String(error?.message || error || "").toLowerCase();
    return (
        text.includes("502") ||
        text.includes("503") ||
        text.includes("504") ||
        text.includes("failed to fetch") ||
        text.includes("networkerror") ||
        text.includes("network request failed")
    );
}

export function backoffDelayMs(failureCount, options = {}) {
    const baseMs = Number(options.baseMs || 5000);
    const maxMs = Number(options.maxMs || 120000);
    const jitterMs = Number(options.jitterMs || 500);
    const safeFailureCount = Math.max(0, Number(failureCount || 0));

    const exponential = Math.min(maxMs, baseMs * Math.pow(2, safeFailureCount));
    const jitter = Math.floor(Math.random() * Math.max(0, jitterMs));
    return Math.min(maxMs, exponential + jitter);
}

export function shouldThrottleRetry(lastFailureAtMs, failureCount, options = {}) {
    if (!lastFailureAtMs) return false;
    const waitMs = backoffDelayMs(failureCount, options);
    return (Date.now() - Number(lastFailureAtMs)) < waitMs;
}
